import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { changeStep } from '../actions/wizardActions';
import {
    stepTitlesAndCompletedSelector,
    isCompletingSelector,
    activeStepSelector,
    canFinishSelector,
    completedSelector,
    errorSelector,
    activatedSelector,
    activationErrorSelector
} from '../selectors/wizardSelectors';
import StepperHeader from '../components/StepperHeader/StepperHeader';

const mapStateToProps = createStructuredSelector({
    steps: stepTitlesAndCompletedSelector,
    isCompleting: isCompletingSelector,
    activeStep: activeStepSelector,
    canFinish: canFinishSelector,
    completed: completedSelector,
    error: errorSelector,
    activated: activatedSelector,
    activationError: activationErrorSelector
});

const mapDispatchToProps = { changeStep };

export default withTranslation(['common', 'wizard'])(
    withRouter(
        connect(mapStateToProps, mapDispatchToProps)(StepperHeader)
    )
);
